import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cutSeparator',
})
export class CutSeparatorPipe implements PipeTransform {
  transform(value: string): string {
    return value.replaceAll('||', '');
  }
}
